import { ButtonTypes, getFontCss, styleConstants, themeConstants } from '@paywithextend/components'
import React, { useState } from 'react'
import Button, { ButtonDesigns } from 'src/components/Button/Button'
import SvgUsers03 from 'src/components/Svgs/SvgUsers03'
import UserDropdown, {
  UserDropdownProps,
} from 'src/components/UserDropdown/UserDropdown'
import { useClickOutside } from 'src/hooks'
import Trns from 'src/localization/Trns'
import variables from 'src/style/variables.json'
import { css } from 'styled-components'

interface UtilityToolbarQuickFilterProps {
  userDropdownProps: UserDropdownProps
}

const UtilityToolbarQuickFilter: React.FC<UtilityToolbarQuickFilterProps> = ({
  userDropdownProps,
}): React.ReactElement => {
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useClickOutside(() => {
    setIsOpen(false)
  })

  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        position: relative;
        align-items: flex-end;
      `}
      ref={dropdownRef}
    >
      <div
        css={css`
          position: relative;
          display: inline-block;
        `}
      >
        <Button
          type={ButtonTypes.button}
          testId = 'quickFilterButton'
          design={ButtonDesigns.designUtilityToolbar}
          text={
            <span css={css`
              ${getFontCss(
                14,
                themeConstants.colors.cta,
                styleConstants.fontFamilies.medium,
              )};
            `}>
              <Trns source={'Card User'} />
            </span>
          }
          onClick={(): void => {
            setIsOpen(!isOpen)
          }}
          image={
            <span
              css={css`
                max-width: ${variables.units['base-unit-4']}px;
                max-height: ${variables.units['base-unit-4']}px;
              `}
            >
              <SvgUsers03 />
            </span>
          }
        />
      </div>
      {isOpen && (
        <div
          css={css`
            position: absolute; // Change to absolute positioning
            top: 100%; // Position below the button
            right: ${variables.units[
              'base-unit-0'
            ]}px; // aligns dropdown to the right of the button
            padding: ${variables.units['base-unit-5']}
              ${variables.units['base-unit-0']}px;
            z-index: 4;
            width: 347px;
            display: flex;
            flex-direction: column;
            margin-top: ${variables.units['base-unit-1']}px;
          `}
        >
          <UserDropdown {...userDropdownProps} />
        </div>
      )}
    </div>
  )
}

export default UtilityToolbarQuickFilter
